import React from "react";
import { useHistory } from "react-router";

import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import CloseIcon from "@mui/icons-material/Close";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
} from "@mui/material";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    minWidth: 650,
    padding: theme.spacing(2),
    borderRadius: 8,

    [theme.breakpoints.down("sm")]: {
      minWidth: 350,
      padding: theme.spacing(1, 1), // Reducir padding en acciones para móviles
    },
  },
  "& .MuiDialogContent-root": {
    /* padding: theme.spacing(2), */
    textAlign: "center",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2, 2),
    justifyContent: "center",
  },
}));

const BootstrapDialogTitle = styled(DialogTitle)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(2),
  position: "relative",
  margin: "0",
  "& .MuiIconButton-root": {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function BootstrapDialogTitleComponent(props) {
  const { children, onClose, ...other } = props;

  return (
    <BootstrapDialogTitle {...other}>
      {children}
      {onClose ? (
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </BootstrapDialogTitle>
  );
}

BootstrapDialogTitleComponent.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const IconWrapper = styled("div")(({ theme, type }) => {
  let backgroundColor;
  let color;

  switch (type) {
    case "error":
      backgroundColor = theme.palette.error.main;
      color = theme.palette.error.contrastText;
      break;
    case "warning":
      backgroundColor = theme.palette.warning.main;
      color = theme.palette.warning.contrastText;
      break;
    case "info":
      backgroundColor = theme.palette.info.main;
      color = theme.palette.info.contrastText;
      break;
    case "success":
      backgroundColor = theme.palette.success.main;
      color = theme.palette.success.contrastText;
      break;
    default:
      backgroundColor = theme.palette.grey[500];
      color = theme.palette.common.white;
  }

  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor,
    color,
    width: 48,
    height: 48,
    borderRadius: "50%",
    margin: "0 auto",
    marginBottom: theme.spacing(2),
  };
});

const ModalVerificarDatosCliente = ({
  open,
  title,
  setOpen,
  children,
  handlePaymentConfirm,
}) => {
  const navigate = useHistory();

  const navegarHome = () => {
    navigate.push("/initialHome");
  };

  return (
    <BootstrapDialog
      onClose={() => setOpen()}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <BootstrapDialogTitleComponent
        id="customized-dialog-title"
        onClose={() => setOpen()}
      >
        <IconWrapper type={"warning"}>
          <WarningAmberIcon fontSize="large" />
        </IconWrapper>
        <Typography variant="h3" sx={{ margin: "0" }}>
          {title}
        </Typography>
      </BootstrapDialogTitleComponent>

      {children && <DialogContent dividers>{children}</DialogContent>}

      <DialogActions>
        <SCSGenericButton
          size={40}
          /* type={type} */
          autoFocus
          onClick={handlePaymentConfirm}
          titulo={"SI"}
        />

        <SCSGenericButton
          size={40}
          autoFocus
          onClick={() => setOpen()}
          titulo={"NO"}
        />
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ModalVerificarDatosCliente;
